import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { MODAL, ACCOUNT } from '../../reduxs'
import {
  CREATE_DEFAULT,
  MODAL_STATUS,
  MENU,
  checkPermission,
  ROUTE,
  PERMISSION_PAGE
} from '../../helpers'
import { IMG } from '../../themes'
import { DropDown, ModalStatus, Loader, Topbar } from '../../components'
import { FILTER } from '../../helpers'
import { StyleUserSettings } from './style'

import ReactGA from "react-ga"


const UserSettingsWord = {
  LANGUAGE: {
    TH: 'ภาษา',
    EN: 'Language',
  },
  HISTORY: {
    TH: 'ประวัติ',
    EN: 'history',
  },
  PRIVACY: {
    TH: 'ความเป็นส่วนตัว',
    EN: 'privacy',
  },
  NAME: {
    TH: 'ชื่อ',
    EN: 'Name',
  },
  EMAIL: {
    TH: 'อีเมล',
    EN: 'Email',
  },
}

export class UserSettings extends Component {
  constructor(props) {
    super(props)
    this.languageList = FILTER.LIST_LANGUAGE
    this.state = {
      error: false,
      image: undefined,
      activelanguage: FILTER.LIST_LANGUAGE[0],
    }
    this.service()

    //GA TrackingId
    ReactGA.initialize("UA-153387162-1")
    ReactGA.pageview("User Setting Page")
  }

  trackingHistory () {
    ReactGA.event({
      category: "User_Setting",
      action: "Histoty",
    })
  }

  trackingPrivacy () {
    ReactGA.event({
      category: "User_Setting",
      action: "Privacy",
    })
  }

  service () {
    const { accountAction } = this.props
    accountAction.getProfile({}, () => {
      const { accountReducer } = this.props
      this.setState({
        image: accountReducer.profile ? accountReducer.profile.imageBase64 ? `data:jpg;base64,` + accountReducer.profile.imageBase64 : undefined : undefined,
      })
    })
  }

  modal = {
    openModalConfirm: () => {
      const { modalAction } = this.props
      modalAction.openModalConfirm()
    },
    closeModalConfirm: () => {
      const { modalAction } = this.props
      modalAction.closeModalConfirm()
    },
    closeModalStatus: () => {
      const { modalAction } = this.props
      modalAction.closeModalStatus()
    }
  }

  selectStatus = (data) => {
    const { accountReducer } = this.props
    let language
    if (accountReducer.language === 'EN') {
      language = 'TH'
    } else {
      language = 'EN'
    }
    const {
      accountAction
    } = this.props
    accountAction.selectLanguage(language)
    accountAction.updateProfile({ language })

    ReactGA.event({
      category: "User_Setting",
      action: "Change_language",
      label: accountReducer.language === 'EN' ? 'EN' : 'TH',
    })
  }

  inputImg = (e) => {
    const { modalAction, accountReducer, accountAction } = this.props
    let file = e.target.files[0]
    if (e && file) {
      console.log('file.size', file.size)
      if (file.size > 3145728) { // 3145728 => 3MB
        modalAction.openModalStatus({
          data: { description: CREATE_DEFAULT.LIMIT_FILE3MB[accountReducer.language] }
        })
      }
      else {
        if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = (data) => {
            const image = file
            const params = {
              image
            }
            accountAction.updateProfile(params, () => {
              this.setState({
                image: data.target.result,
              }, () => {

              })
            })


          }
        }
      }
    }
  }

  upload () {
    document.getElementById('selectImage').click()
    ReactGA.event({
      category: "User_Setting",
      action: "Upload_IMG",
    })
  }

  render () {
    const { activelanguage, image } = this.state
    const { accountReducer, modalReducer, settingReducer } = this.props
    const { language } = accountReducer
    const { colorTheme } = settingReducer.settingTheme

    return (
      <StyleUserSettings>
        {modalReducer.status &&
          <ModalStatus
            language={language}
            code={modalReducer.status.code}
            action={modalReducer.status.status ?
              `${CREATE_DEFAULT.EDIT[language]} ${MODAL_STATUS.COMPLELTE[language]}`
              :
              MODAL_STATUS.WARNING[language]
            }
            text={modalReducer.status.status ?
              MODAL_STATUS.SUCCESS[language]
              :
              modalReducer.status.description
            }
            status={modalReducer.status.status}
            onClick={this.modal.closeModalStatus}
            colorTheme={colorTheme}
          />
        }
        
        <Topbar textBreadcrumbStart={MENU.SETTING[language]} />
        {
          !accountReducer.profile ?
            <Loader colorTheme={colorTheme} />
            : accountReducer.profile ?
              <div className='div-content'>
                <div className='profile-setting'>
                  <div className='profile'>
                    <div className='profile-item'>
                      <span className='profile-image'>
                        {image ? <img src={image} alt='' /> : <img src={IMG['user-tie-solid.svg']} alt='' />}
                        {
                          checkPermission(accountReducer.permission, ROUTE.USER_SETTING.ACTION.UPDATE) &&
                          <div className='edit_circle pointer'
                            onClick={this.upload}>
                            <input
                              id='selectImage'
                              hidden
                              type='file'
                              accept='image/x-png,image/jpg,image/jpeg'
                              onChange={this.inputImg}
                              ref={e => this.logo = e}
                              onClick={() => {
                                this.logo.value = ''
                              }}
                            />
                            <img src={IMG['ic_edit_black.svg']} alt=''></img>
                          </div>
                        }
                      </span>
                      <span className='profile-text'>
                        <div className='name' > {UserSettingsWord.NAME[accountReducer.language]} : <span className='name2'> {accountReducer.profile.name} </span> </div>
                        <div className='email'> {UserSettingsWord.EMAIL[accountReducer.language]} : <span className='email2'> {accountReducer.profile.username} </span> </div>
                      </span>
                    </div>
                  </div>
                  <div className='setting'>
                    <div className='setting-item'>
                      {
                        <li className='setting-language margin-bot'>
                          <img src={IMG['ic_language.svg']} alt=''></img>
                          <span className='setting-dropdown'>
                            <p >
                              {UserSettingsWord.LANGUAGE[language]}
                            </p>
                            <DropDown
                              list={this.languageList}
                              value={activelanguage.name[language]}
                              onClickList={this.selectStatus}
                              language={language === 'TH' ? 'EN' : 'TH'}
                              disabled={!checkPermission(accountReducer.permission, ROUTE.USER_SETTING.ACTION.UPDATE)}
                              colorTheme={colorTheme}
                            />
                          </span>
                        </li>
                      }
                    </div>
                  </div>
                </div>
              </div>
              : <div style={{ marginLeft: 55 }}>{PERMISSION_PAGE.NOT_FOUND[language]}</div>
        }
      </StyleUserSettings>
    )
  }
}


const mapStateToProps = ({
  modalReducer,
  userReducer,
  companyReducer,
  accountReducer,
  settingReducer,
}) => {
  return {
    modalReducer,
    userReducer,
    companyReducer,
    accountReducer,
    settingReducer,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    modalAction: bindActionCreators(MODAL.action, dispatch),
    accountAction: bindActionCreators(ACCOUNT.action, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings)
